<script>
    import videojs from 'video.js';

    export default {
        props: {
            src: String,
        },
        data() {
            return {
                player: null,
                options: {
                    autoplay: false,
                    controls: true,
                    fluid: true,
                    sources: [
                        {
                            src: this.src,
                            type: "video/mp4"
                        }
                    ]
                }
            }
        },
        mounted() {
            this.player = videojs(this.$refs.videoPlayer, this.options);
        },
        beforeDestroy() {
            if (this.player) {
                this.player.dispose()
            }
        }
    }
</script>

<template>
    <video ref="videoPlayer" class="video-js"></video>
</template>